// Read-only ownership projection for the editor. Keep source order; never
// attach a project through an empty or ambiguous identifier.
export function buildProjectEditorBlocks(experience) {
    const groups = experience.project_groups || [];
    const missions = experience.missions || [];
    const counts = new Map();
    groups.forEach(group => { if (group.id) counts.set(group.id, (counts.get(group.id) || 0) + 1); });
    const links = new Map(groups.flatMap((group, index) => group.id && counts.get(group.id) === 1 ? [[group.id, index]] : []));
    const blocks = [];
    const seen = new Set();
    missions.forEach((mission, index) => {
        const groupIndex = mission.group_id ? links.get(mission.group_id) : undefined;
        const previous = blocks[blocks.length - 1];
        if (groupIndex !== undefined && previous?.type === 'group' && previous.groupIndex === groupIndex) {
            previous.projects.push({ mission, index });
        } else if (groupIndex !== undefined) {
            blocks.push({ type: 'group', groupIndex, first: !seen.has(groupIndex), projects: [{ mission, index }] });
            seen.add(groupIndex);
        } else {
            blocks.push({ type: 'project', projects: [{ mission, index }] });
        }
    });
    groups.forEach((_, groupIndex) => {
        if (!seen.has(groupIndex)) blocks.push({ type: 'group', groupIndex, first: true, projects: [] });
    });
    const last = new Map();
    blocks.forEach((block, index) => { if (block.type === 'group') last.set(block.groupIndex, index); });
    return blocks.map((block, index) => ({ ...block, last: block.type === 'group' && last.get(block.groupIndex) === index }));
}
